export default __webpack_public_path__ + "static/media/list-empty-state.83fb2231.svg";